import React from "react";
import { Modal } from "antd";
import "./ViewModal.css";

function ViewModal({ modalStatus, title, closeModal, children, width = 550 }) {
  return (
    <Modal
      centered
      title={title}
      width={width}
      open={modalStatus}
      onCancel={() => closeModal()}
      footer={null}
    >
      {children}
    </Modal>
  );
}

export default ViewModal;
